import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.806 9.125H1L9.125 1l8.125 8.125h-1.806M2.806 9.125v6.32A1.806 1.806 0 004.61 17.25h9.028a1.806 1.806 0 001.805-1.806V9.125"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.417 17.25v-5.417a1.805 1.805 0 011.805-1.805h1.806a1.806 1.806 0 011.805 1.805v5.417"
      ></path>
    </svg>
  )
}

export default Icon
